export { default } from './HotelPayment';
